/* Badan Studios — Catálogo: panel «Filtros» y orden.
   - El orden se aplica al cambiarlo.
   - En el panel se marcan varios filtros y se aplican a la vez con «Ver resultados». */
(function () {
  'use strict';

  document.querySelectorAll('[data-collection-filters]').forEach(function (form) {
    var drawer = form.querySelector('[data-filters-drawer]');

    function cleanAndSubmit() {
      // Quita los campos vacíos para que la URL quede limpia
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.name && el.type !== 'checkbox' && el.value === '') el.disabled = true;
      });
      form.submit();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      cleanAndSubmit();
    });

    var sort = form.querySelector('[data-sort-select]');
    if (sort) sort.addEventListener('change', cleanAndSubmit);

    if (!drawer) return;

    function close() {
      drawer.removeAttribute('open');
    }

    drawer.addEventListener('toggle', function () {
      document.body.classList.toggle('filters-open', drawer.open);
      if (drawer.open) {
        var first = drawer.querySelector('.filters-drawer__close');
        if (first) first.focus();
      }
    });

    drawer.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.open) {
        close();
        drawer.querySelector('summary').focus();
      }
    });
  });
})();
